import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

interface ShipperPreferencesConfig {
  create_shipment_form_view: "FULL" | "PUBLIC_SHIPMENT";
}

interface Props {
  fallbackFormView: "FULL" | "PUBLIC_SHIPMENT";
}

export function useShipperPreferences(props: Props) {
  const { fallbackFormView } = props;
  const { role } = useRoleContext();

  const url = role?.id ? `/shippers/${role.id}/preferences` : null;

  const { data, loading, error, refetch } = useSwrFetch<ShipperPreferences>({
    url,
    errorMessage: "Failed to fetch shipper preferences",
    errorMessageKey: "message",
    // if the request fails for whatever reason, do not retry. Downstream consumers
    // are prepated to handle this with a fallback value.
    swrOptions: { shouldRetryOnError: false },
  });

  // Default to the fallback immediately. If real preferences load, use those instead.
  // This avoids gating the form on the preferences fetch completing.
  const preferences: ShipperPreferencesConfig = {
    create_shipment_form_view:
      data?.create_shipment_form_view ?? fallbackFormView,
  };

  return {
    preferences,
    loading,
    error,
    refetch,
  };
}
